import { USState } from '../interfaces/us-state.interface';

export class CompatibleStates {
  public static isIncompatible(state:USState) {
    switch (state.abbreviation) {
      case 'NY':
      case 'MT':
      case 'WA':
        return true;
      default:
        return false;
    }
  }
}
